import Image from "next/image";
import { BrowserView, MobileView } from "react-device-detect";
import { useDispatch, useSelector } from "react-redux";
import { selectPromoCTAClicked, selectPromoCompanion, selectPromoVideoProgress, setPromoCTAClicked } from "@/store/slices/promoCompanion";

const Companion = () => {
  const data = useSelector(selectPromoCompanion);
  const progress = useSelector(selectPromoVideoProgress);
  const ctaClicked = useSelector(selectPromoCTAClicked);

  const dispatch = useDispatch();

  const ctaClick = () => {
    window.open(data?.cta.url, "_blank");
    if (ctaClicked) return;
    dispatch(setPromoCTAClicked(true));
  }

  if (!data) return <></>;

  return (
    <>
      <BrowserView className="absolute left-0 bottom-0 w-full">
        <div className="h-1 bg-yellow-500" style={{
          width: `${progress}%`
        }} />
      </BrowserView>
      {
        (data.title || data.subtitle) && <BrowserView className="absolute bottom-3 left-2 bg-black/75 rounded-lg text-white">
          <div className="flex items-center justify-between gap-4 w-92 py-2 px-4">
            <div className="flex items-center gap-4">
              {data.logo && <Image className="my-0" src={data.logo} alt={data.title} width={32} height={32} />}
              <div className="flex flex-col">
                <span className="text-sm font-medium">{data.title}</span>
                <span className="text-xxs font-normal">{data.subtitle}</span>
              </div>
            </div>
            {
              !!data.cta?.text && <button onClick={ctaClick} className="btn-primary text-sm px-2 py-1">{data.cta.text}</button>
            }
          </div>
        </BrowserView>
      }
      
      <MobileView className="bg-white text-black w-full h-full border-4 border-t-0 border-slate-600">
        <div className="h-1 bg-yellow-500" style={{
          width: `${progress}%`
        }} />
        <div className="flex items-center justify-between gap-4 w-full p-2">
          <div className="flex items-center gap-2">
            {data.logo && <Image className="my-0" src={data.logo} alt={data.title} width={32} height={32} />}
            <div className="flex flex-col">
              <span className="text-sm font-medium">{data.title}</span>
              <span className="text-xxs font-normal">{data.subtitle}</span>
            </div>
          </div>
          {
            !!data.cta?.text &&  <button onClick={ctaClick} className="btn-primary text-sm px-2 py-1">{data.cta.text}</button>
          }
        </div>
      </MobileView>
    </>
  );
}

export default Companion;